import React, { useState } from 'react';
import { HomePage } from './pages/HomePage';
import { ProductArchivePage } from './pages/ProductArchivePage';
import { ProductDetailPage } from './pages/ProductDetailPage';
type PageView = 'home' | 'archive' | 'detail';
export function App() {
  const [currentView, setCurrentView] = useState<PageView>('home');
  const [selectedProductId, setSelectedProductId] = useState<number | undefined>(undefined);
  const handleNavigate = (page: PageView, productId?: number) => {
    setCurrentView(page);
    if (productId) {
      setSelectedProductId(productId);
    }
    window.scrollTo(0, 0);
  };
  return <>
      {currentView === 'home' && <HomePage onNavigate={handleNavigate} data-id="element-0" />}
      {currentView === 'archive' && <ProductArchivePage onNavigate={handleNavigate} data-id="element-1" />}
      {currentView === 'detail' && selectedProductId && <ProductDetailPage productId={selectedProductId} onNavigate={handleNavigate} data-id="element-2" />}
    </>;
}